__turbopack_context__.v({
  "videoModalContent": "PRiDgq_videoModalContent",
});
